import { ReceiveChatConversationMessagesDto } from '@endion/types';
import { CustomerChatbotContextProvider } from '../context/customer-chatbot-context';
import { CreateEndionChatbotOptions } from '../endion-chatbot';
import { Chat } from './chat';

export type AppProps = {
  context?: ReceiveChatConversationMessagesDto['context'];
  chatbotApiKey: string;
  isRemounted?: boolean;
  replaceDefaultClickBehaviorWithLink?: CreateEndionChatbotOptions['replaceDefaultClickBehaviorWithLink'];
  showTrigger?: boolean;
};

function App({ chatbotApiKey, replaceDefaultClickBehaviorWithLink, context, showTrigger }: AppProps) {
  return (
    <CustomerChatbotContextProvider
      chatbotApiKey={chatbotApiKey}
      websiteProvidedContext={context}
      showTrigger={showTrigger}
    >
      <Chat replaceDefaultClickBehaviorWithLink={replaceDefaultClickBehaviorWithLink} />
    </CustomerChatbotContextProvider>
  );
}

export default App;
